// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"PieChart_skeletonWrapper__byDSd","heading":"PieChart_heading__X7qTb"};